import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})
export class BecasService {
  API_URL = environment.apiURL + 'becas';

  constructor(private httpClient: HttpClient) {}
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  };
  sendFormHomeBeca(beca): Observable<any> {
    return this.httpClient.post<any>(environment.apiURL + 'codigo_descuentos/register', JSON.stringify(beca), this.httpOptions)
      .pipe(retry(1));
  }
  getBecaByCI(ci): Promise<any> {
    const url = environment.apiURL + 'codigo_descuentos/ci' + '/' + ci;
    return this.httpClient.get<any>(url).toPromise().catch((err) => {
    });
  }
  getBecaActive(): Observable<any>{
    const url = environment.apiURL + 'codigo_descuentos/active';
    return this.httpClient.get<any>(url);
  }
  getAllBecas(): Observable<any>{
    const url = environment.apiURL + 'codigo_descuentos/getAllBecas';
    return this.httpClient.get<any[]>(url);
  }
  getAllRecords(strURL): Observable<any>{
    const url = environment.apiURL + strURL;
    return this.httpClient.get<any[]>(url);
  }
  becaRecordUpdate(data){
    const url = environment.apiURL + 'dtoPeportes/update';
    return this.httpClient.put<any>(url, data);
  }
  becaActivated(code): Observable<any>{
    const url = environment.apiURL + 'codigo_descuentos/activarBeca' + '/' + code;
    return this.httpClient.post<any>(url, {});
  }
  becaCreate(data): Observable<any>{
    const url = environment.apiURL + 'codigo_descuentos/create';
    return this.httpClient.post<any>(url, data);
  }
  becaUpdate(data): Observable<any>{
    const url = environment.apiURL + 'codigo_descuentos/update';
    return this.httpClient.put<any>(url, data);
  }
  becaDelete(id): Observable<any>{
    const url = environment.apiURL + 'codigo_descuentos/delete' + '/' + id;
    return this.httpClient.delete<any>(url);
  }
  recordDelete(id): Observable<any>{
    const url = environment.apiURL + 'dtoPeportes/delete' + '/' + id;
    return this.httpClient.delete<any>(url);
  }
  // Send Form Data
  sendFormRequest(beca): Observable<any> {
    return this.httpClient.post<any>(this.API_URL, JSON.stringify(beca), this.httpOptions)
      .pipe(retry(1), catchError(this.handleError));
  }
  //
  // Error handling
  handleError(error): any {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    window.alert(errorMessage);
    return throwError(errorMessage);
  }
}
